import { Grid, Box } from '@mui/material'

import { useToolBuilder } from '../../Hook'
import TabPanel from 'components/Shared/TabPanel'

function Panel(props: any) {
  const { toolTabs } = useToolBuilder()

  return (
    <Grid item xs={12} md={4}>
      {toolTabs.map((tool, index) => (
        <TabPanel
          key={tool}
          name={tool}
          index={index}
          value={props.toolTabValue}
        >
          <Box
            px={3}
            py={6}
            bgcolor="white"
            height={{ md: 'calc(-216px + 100vh)' }}
            sx={{ overflowY: 'scroll', overflowX: 'hidden' }}
          >
            {props.children}
          </Box>
        </TabPanel>
      ))}
    </Grid>
  )
}

export default Panel
